import script from "./MarketplaceReviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketplaceReviews.vue?vue&type=script&setup=true&lang=ts"

import "./MarketplaceReviews.vue?vue&type=style&index=0&id=756accf6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756accf6"]])

export default __exports__